import AttendanceListHeading from './AttendanceListHeading'

export default AttendanceListHeading
